module.exports = __webpack_public_path__ + "img/vg.b1c59053.svg";